import React, { useState } from 'react';
import styles from './Navbar.module.css';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const gym = useSelector(state => state.gym);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('gym');
    window.location.reload();
  };

  return (
    <nav className={`${styles.navbar} ${menuOpen ? styles.open : ''}`}>
      <div className={styles.menuToggle} onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className={styles.left}>
        <button onClick={() => navigate('/add-user')}>Cargar Socio</button>
        <button onClick={() => navigate('/add-trainer')}>Cargar Trainer</button>
        <button onClick={() => navigate('/users')}>Lista Socios</button>
        <button onClick={() => navigate('/trainers')}>Lista Trainers</button>
        <button onClick={() => navigate('/dni-login')}>Ingreso por DNI</button>
      </div>

      <div className={styles.center}>
        <span onClick={() => navigate('/home')}>
          {gym?.name || 'Gimnasio'}
        </span>
      </div>

      <div className={styles.right}>
        <button onClick={handleLogout}>Cerrar sesión</button>
      </div>
    </nav>
  );
};


export default Navbar;